export class SignaalkaartAntwoord {

  static deserialize(dto: SignaalkaartAntwoordDto): SignaalkaartAntwoord {
    return new SignaalkaartAntwoord(
      dto.id,
      dto.signaalkaartId,
      dto.signaalkaartVersie,
      dto.clientId,
      dto.auteurId,
      dto.auteurNummer,
      dto.antwoorden.map(antwoord => VraagAntwoord.newVraagAntwoord(antwoord.vraagId, antwoord.antwoorden)),
      new Date(dto.creatieTijdstip)
    );
  }

  constructor(private id: string,
              private signaalkaartId: string,
              private signaalkaartVersie: number,
              private clientId: string,
              private auteurId: string,
              private auteurNummer: string,
              private antwoorden: Array<VraagAntwoord>,
              private creatieTijdstip: Date,
  ) {
  }

  getId(): string {
    return this.id;
  }

  getSignaalkaartId(): string {
    return this.signaalkaartId;
  }

  getSignaalkaartVersie(): number {
    return this.signaalkaartVersie;
  }

  getClientId(): string {
    return this.clientId;
  }

  getAuteurId(): string {
    return this.auteurId;
  }

  getAuteurNummer(): string {
    return this.auteurNummer;
  }

  getAntwoorden(): Array<VraagAntwoord> {
    return this.antwoorden;
  }

  getAntwoord(vraagId: string): VraagAntwoord {
    return this.antwoorden.find(antwoord => antwoord.hasVraagId(vraagId));
  }

  getCreatieTijdstip(): Date {
    return this.creatieTijdstip;
  }
}

export class VraagAntwoord {

  static newVraagAntwoord(vraagId: string, antwoord: any): VraagAntwoord {
    if (antwoord instanceof Array) {
      return new VraagAntwoord(vraagId, antwoord);
    }
    return new VraagAntwoord(vraagId, [antwoord]);
  }

  constructor(private vraagId: string,
              private antwoorden: Array<string>) {
  }

  getVraagId(): string {
    return this.vraagId;
  }

  hasVraagId(vraagId: string): boolean {
    return this.vraagId === vraagId;
  }

  getAntwoorden(): Array<string> {
    return this.antwoorden;
  }

  getAntwoordenAsString(): string {
    return this.antwoorden.join(', ');
  }

}

export interface SignaalkaartAntwoordDto {
  id: string;
  signaalkaartId: string;
  signaalkaartVersie: number;
  clientId: string;
  auteurId: string;
  auteurNummer: string;
  antwoorden: Array<VraagAntwoordDto>;
  creatieTijdstip: string;
}

export interface VraagAntwoordDto {
  vraagId: string;
  antwoorden: Array<string>;
}
